<template>
    <v-container fluid class="py-0 px-0 my-0">
        <v-container fluid style="background: #000; color: white;" class="px-0  tituloPres">
            <v-row class="mx-3 py-8">
                <v-col cols="12">
                    <h3 v-if="!listo">Cotización...</h3>
                    <h3 v-else class="text-uppercase">{{ cotizacion.fields.nombre }}</h3>
                </v-col>
                <v-col cols="12" class="right" v-if="listo && presentacion.fields.descripcion">
                    <!--<h2 class="d-none d-">
                        Valor: {{ formatPrice(cotizacion.fields.valor_final) }} <span class="d-none d-lg-inline">|</span><span class="d-block d-lg-none"><br /></span> Precio: {{ formatPrice(cotizacion.fields.precio_final) }}
                    </h2>-->
                    <p class="cotizacion_descripcion mb-0">{{ cotizacion.fields.descripcion }}</p>
                </v-col>
            </v-row>

            <!--<v-row v-if="listo">
                <v-col cols="12">
                    <p>Cotización: {{ cotizacion.id }}</p>
                    <p>Tipos Proyectos: {{ tiposProyectoFiltrados(cotizacion.id).length }}</p>
                </v-col>
            </v-row>-->
        </v-container>

        <v-container fluid class="px-0 py-0">
            <v-row v-for="(tipoProyecto, key) in tiposProyectoFiltrados(cotizacion.id)" :key="'tipoProyecto-' + key">
                <v-col cols="12" class="py-0">
                    <TipoProyecto :id-cotizacion="cotizacion.id" :tipo-proyecto="tipoProyecto"></TipoProyecto>
                </v-col>
            </v-row>
        </v-container>
    </v-container>

</template>

<script>
import TipoProyecto from "@/components/TipoProyecto";
import {mapState, mapGetters} from 'vuex';

export default {
    name: "Cotizacion",
    props: {
        idCotizacion: {
            required: true,
            type: String,
        }
    },
    components: {
        TipoProyecto
    },
    data() {
        return {
            cotizacion: {
                id: undefined,
                fields: {
                    valor_final: 0,
                    precio_final: 0,
                }
            }
        }
    },
    watch: {
        'loading': function () {
            this.setCotizacion();
        }
    },
    computed: {
        ...mapGetters(["buscarCotizacion", "tiposProyectoFiltrados"]),
        ...mapState(["loading", "presentacion"]),
        listo() {
            return !!this.cotizacion.id;
        }
    },
    methods: {
        setCotizacion() {
            if(this.cotizacion.id === undefined) {
                this.cotizacion = this.buscarCotizacion(this.$props.idCotizacion);
            }
        }
    },
    mounted() {
        this.setCotizacion();
    }
}
</script>

<style scoped>
.cotizacion_descripcion {
    font-family: "Expressway Rg", sans-serif;
    font-size: 1rem;
    line-height: 1.3rem;
}
</style>
